var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"sr-only"},[_vm._v("En cours de chargement.")]),_c('font-awesome-icon',{attrs:{"icon":['fas', 'spinner'],"size":"3x","pulse":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }